import React from 'react';
import { Card } from '@nexus/lib-react/dist/core/Card/Card';
import ReturnsStatus from './ReturnsStatus';
import ReturnsStatusInfo from './ReturnsStatusInfo';
import { ClaimStatusKey, ReturnStatusKey } from '../../../../../typings/returns';
import useGetReturnsStatusKeyName from '../../hooks/useGetReturnsStatusKeyName';
import makePrice from '../../utils/makePrice';

import S from './style/ReturnsAdBlock';

interface ReturnsAdBlockProps {
  returnId: string;
  status: ReturnStatusKey | ClaimStatusKey;
  title: string;
  price: number;
  currency: string;
  actionDeadline: string;
  timeToNegotiate?: number;
  showRedirectionStyles?: boolean;
  image?: string;
  onAdPreviewClick?: () => void;
  postingDeadlineStart?: string;
  postingDeadlineEnd?: string;
}

const IMAGE_SIZE = '512';
const LOCALE_LANG = 'pl-PL';

const ReturnsAdBlock: React.FC<ReturnsAdBlockProps> = ({
  returnId,
  status,
  title,
  price,
  currency,
  actionDeadline,
  timeToNegotiate,
  showRedirectionStyles,
  image,
  onAdPreviewClick,
  postingDeadlineStart,
  postingDeadlineEnd,
}) => {
  const statusKeyName = useGetReturnsStatusKeyName(status);
  const statusInfoKeyName = useGetReturnsStatusKeyName(status, true);

  const localizedPrice = makePrice(LOCALE_LANG);
  const formattedPrice = localizedPrice.parseAndFormat(price, currency);

  const adImage = image?.replace(/{width}|{height}/g, IMAGE_SIZE);

  return (
    <>
      <S.Block
        onClick={onAdPreviewClick}
        showRedirectionStyles={showRedirectionStyles}
        data-cy="returns-ad-block"
      >
        <Card
          type="list"
          title={
            <S.Link data-cy="returns-ad-title" onClick={onAdPreviewClick}>
              {title}
            </S.Link>
          }
          price={formattedPrice}
          location=""
          date=""
          isFavorite
          favoriteAction={onAdPreviewClick}
          renderFavorite={() => showRedirectionStyles && <S.ChevronIcon />}
          renderThumbnail={props => <Card.Thumbnail type="list" thumbnail={adImage} {...props} />}
        />
      </S.Block>
      <ReturnsStatus textKeyName={statusKeyName} />
      <ReturnsStatusInfo
        textKeyName={statusInfoKeyName}
        actionDeadline={actionDeadline}
        postingDeadlineStart={postingDeadlineStart}
        postingDeadlineEnd={postingDeadlineEnd}
        returnId={returnId}
        timeToNegotiate={timeToNegotiate}
      />
    </>
  );
};

export default ReturnsAdBlock;
